// Central brand config for Featherbomb
export const BRAND = {
  name: "Featherbomb",
  domain: "myfeatherbomb.com",
  tagline: "Gravity is optional. Fun is mandatory.",
  logo:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_08629876-620c-4614-9541-e4ec6b40f56e/artifacts/kp7i7ptu_FEATHERBOMB_LOGO%40300x.webp",
  colors: {
    red: "#EE4026",
    blue: "#184786",
    dark: "#212121",
    gray: "#9E9E9E",
    light: "#F5F5F5",
  },
};

// Paste your Clover Hosted Checkout link here when ready.
// Square Hosted Checkout link.
export const CLOVER_CHECKOUT_URL = "https://square.link/u/1URv1bXi";
export const CHECKOUT_URL = "https://square.link/u/1URv1bXi";

export const PRODUCT = {
  name: "Featherbomb",
  edition: "Classic Edition",
  price: 19.99,
  compareAt: 25.99,
  rating: 4.9,
  reviews: 2143,
  blurb:
    "One weighted base. A burst of aerodynamic feathers. Infinite rallies. The kick toy that turns any patch of ground into a court.",
  colorways: [
    { id: "porcelain", name: "Snow Dragon", hex: "#FFFFFF", ring: "#184786" },
  ],
  specs: [
    ["Feathers", "4 hand-set, cruelty-free goose quills"],
    ["Base", "High-bounce polymer, weighted core"],
    ["Weight", "22 grams — tuned for flat, true flight"],
    ["Cap", "Weatherproof spin cap"],
    ["Ages", "8 to 108"],
  ],
  features: [
    {
      title: "Easy to Learn",
      subtitle: "Beginner-friendly flight",
      text: "The feathers slow things down, giving you more time to react, kick and find your rhythm.",
    },
    {
      title: "Made to Kick",
      subtitle: "Weighted base",
      text: "The weighted base gives every kick a satisfying click sound. Music to your ears as you beat your personal best.",
    },
    {
      title: "Play Anywhere",
      subtitle: "Grab it and go",
      text: "Park, backyard, beach, sidewalk or office. You don't need a court, a net or even a plan!",
    },
  ],
};

export const IMAGES = {
  parkJam:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/xm3rx5eu_Screenshot%202026-08-19%20225211.jpg",
  craft:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/l3gdp0zk_ChatGPT%20Image%20Aug%2019%2C%202026%2C%2010_16_26%20PM.png",
  origin:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/15uxlffb_ChatGPT%20Image%20Aug%2019%2C%202026%2C%2010_09_50%20PM.png",
  featherBox:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/8z6r54bg_87701b60-51a2-4ab9-9e35-84a8021cb1605.png",
  packaging:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/wz0q9tb6_c1a2c38e-89c2-487b-b045-8f5269c0b4c9.png",
  productReal:
    "https://customer-assets-7cd3h4nn.emergentagent.net/job_bomb-store-demo/artifacts/1tgv2n2t_ChatGPT%20Image%20Aug%2019%2C%202026%2C%2008_11_39%20PM.png",
  productHero:
    "https://static.prod-images.emergentagent.com/jobs/08629876-620c-4614-9541-e4ec6b40f56e/images/7fdc56c06c2c2009bdcb4487e860d14079c03120a870892d76f37a786ff27f30.jpeg",
  productDetail:
    "https://static.prod-images.emergentagent.com/jobs/08629876-620c-4614-9541-e4ec6b40f56e/images/ce6712fa8e7efa6fb98fd8e9a25889163f48bef46294e2249dfbb8de597cf96c.jpeg",
  productAngle:
    "https://static.prod-images.emergentagent.com/jobs/08629876-620c-4614-9541-e4ec6b40f56e/images/39b6196ae08a100bc0cc63968ebd7bbcfc8b2f505152a54530149a7635c9d64a.jpeg",
  jamGroup:
    "https://images.pexels.com/photos/36718734/pexels-photo-36718734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  jamUrban:
    "https://images.pexels.com/photos/36692446/pexels-photo-36692446.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  friendsSunset:
    "https://images.unsplash.com/photo-1520880867055-1e30d1cb001c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  parkPlay:
    "https://images.unsplash.com/photo-1758798478573-d653d9b6ac6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "The Origin",
    text: "Featherbomb started with a trip back to Bayuquan in Northeastern China.\n\nEvery morning and evening, people gathered outside to play **jianzi**. Kids, parents, grandparents, friends. People looked forward to their daily movement and being present in each other's company.\n\nI joined in and got hooked... partly on beating my personal best, but mostly on how good it felt to move, break a sweat and connect with people in the community.\n\nI kept thinking, my friends back in North America would love this! What I didn't realize was how far back this simple game goes.\n\nJianzi has been played in China for centuries, tracing back to the **Han Dynasty** and eventually evolving into the competitive sport of jianqiu. In 1984, jianqiu was officially recognised by China's State Physical Culture and Sports Commission as a formal **competitive sport**.\n\nBut on the streets, in parks, and in everyday life, it has always been something simpler:\n\n**A game that brings people together.**",
  },
  {
    n: "02",
    title: "Reimagining Jianzi",
    text: "Through the jianzi community's referral, we connected with a craftsman who has been making jianzi for more than 20 years. Together, we refined the design to make it approachable for beginners.\n\nHand-set, **cruelty-free feathers**, a durable rubber base, and carefully measured weights made from **recycled metal scraps** work together to shape its flight.\n\nThe result is a slow, readable hang time: perfect for learning, reacting, and keeping the game going.\n\nWe brought a few prototypes back to Canada to test with friends, and everyone loved it. We wanted a name that just slips off the tongue and one afternoon, **Featherbomb** came to us.",
  },
  {
    n: "03",
    title: "Screens Down. Feathers Up.",
    text: "Somewhere along the way, moving became another thing we had to schedule, and hanging out started happening through screens.\n\nFeatherbomb is a ridiculously simple way to shift that.\n\nKick it alone for five minutes. Pass it around with friends. Bring it to the park, beach, backyard, family BBQ or office. There's no court, no complicated rules, and no skill level you need to reach.\n\n**One person becomes two. Two becomes a flock.**\n\nYou're moving without thinking about the workout and connecting without staring at a screen.",
  },
];
